import * as React from "react";
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { useSelector } from "react-redux";
import Header from 'components/Header';
import Footer from 'components/Footer';
import SkipNavigationLink from 'components/SkipNavigationLink';
import { MAIN_CONTENT_ID } from 'components/SkipNavigationLink';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Chat from 'components/Chat';
import { useDispatch } from "react-redux";
import { setOpen as setChatOpen } from 'components/Chat/slice';

import theme from 'utils/theme';

import 'styles/app.scss';

const Empty = ({children}) => children;

const Layout = props => {
	const { children } = props;
	const locked = useSelector((state) => state.body?.locked);
	const RecaptchaComponent = (process.env.RECAPTCHA_SITE_KEY ? GoogleReCaptchaProvider : Empty);
	const dispatch = useDispatch();
	const { pageContext } = props;

	React.useEffect(() => {
		const watchForSeemore = (evt) => {
			const parentLink = evt.target.closest('a');
			if (parentLink?.href) {
				const url = new URL(parentLink.href);
				if (url.hash.slice(1) === 'seemore') {
					evt.preventDefault();
					evt.stopPropagation();
					dispatch(setChatOpen(true));
				}
			}
		};
		if (document !== undefined) {
			if (locked){
				document.body.style.setProperty('--st', -(document.documentElement.scrollTop) + "px");
				document.body.classList.add('locked');
			}
			else document.body.classList.remove('locked');
		}
		document.body.addEventListener('click', watchForSeemore, true);
		return () => {
			document.body.removeEventListener('click', watchForSeemore, true);
		}
	}, [locked, dispatch]);

	return (
		<div className="root">
			<ThemeProvider theme={theme}>
				<CssBaseline>
					<RecaptchaComponent reCaptchaKey={process.env.RECAPTCHA_SITE_KEY}>
						<SkipNavigationLink />
						<Chat />
						<Header uri={props.uri} pageContext={pageContext} />
						<section id={MAIN_CONTENT_ID} aria-label="Start of content"></section>
						<Box component={"main"} className={`page-${props?.location?.pathname.replace(/\//gm, "")}`}>
							{children}
						</Box>
						{pageContext?.includeFooter !== false && <Footer /> }
					</RecaptchaComponent>
				</CssBaseline>
			</ThemeProvider>
		</div>
	)
}

export default Layout;